const createObjectWithArray = (array, identifier) => {
    let iterator,
      responseObject = new Object();
    for (let i = 0; i < array.length; i++) {
      iterator = array[i];
      responseObject[iterator[identifier]] = iterator;
    }
    return responseObject;
  };

  const removeDuplicatesByKey = (array, key) => Object.values(array.reduce((acc, obj) => (acc[obj[key]] = obj, acc), {}));

  const findWithId = (array, id, identifier) => {
  // console.log("array :::", array)
  let iterator;
  for (let i = 0; i < array?.length; i++) {
    iterator = array[i];
    if (iterator[identifier] == id) {
      return iterator;
    }
  }
  return new Object();
};

function removeTypename(obj) {
  if (obj === null || obj === undefined) return obj;

  if (Array.isArray(obj)) {
    return obj.map((item) => removeTypename(item));
  } else if (typeof obj === "object") {
    return Object.keys(obj).reduce((acc, key) => {
      if (key !== "__typename") {
        acc[key] = removeTypename(obj[key]);
      }
      return acc;
    }, {});
  }
  return obj;
}

  export {
    createObjectWithArray,
    removeDuplicatesByKey,
    findWithId,
    removeTypename
  };